import { useSelector, useDispatch } from "react-redux";
import {
  useGetPrivacyPolicyListDataQuery,
  useUpdatePrivacyPolicyTableHeadDataMutation,
} from "../../../store/queries/CMS";
import {
  updateConfig,
  getPrivacyPolicyEditData,
} from "../../../store/slices/CMS/cmsSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import Style from "./contentList.module.scss";
import { useEffect } from "react";

const useContentList = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const parse = require("html-react-parser");
  const dispatch = useDispatch();
  const cmsState = useSelector((state) => state.cms);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const {
    data: privacyPolicyList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetPrivacyPolicyListDataQuery({
    page_size: cmsState?.currentPageSize,
    page: cmsState?.currentPage,
    sort: cmsState?.sortBy,
    sort_order: cmsState?.sortOrder,
    search: cmsState?.search,
  });
  const [updateOrdersFields] = useUpdatePrivacyPolicyTableHeadDataMutation();
  useEffect(() => {
    if (cmsState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [cmsState.clearSelection]);
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (cmsState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = cmsState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      description: (field, data) => (
        <p className={`${Style.limited_lines}`}>{parse(data[field])}</p>
      ),
      alias_description: (field, data) => (
        <p className={`pro-rtl ${Style.limited_lines}`}>{parse(data[field])}</p>
      ),
      alias_name: (field, data) => (
        <p className="pro-rtl">{parse(data[field])}</p>
      ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleCreateClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
      })
    );
  };
  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.selectedId = e?.[0];
        state.isEdit = true;
      })
    );
    dispatch(getPrivacyPolicyEditData(e?.[0]));
  };
  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = false;
        state.isEdit = false;
      })
    );
  };

  return {
    cmsState,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    privacyPolicyList,
    paginationOptions,
    handleEditColumnsClick,
    updateOrdersFields,
    handleCloseModal,
    handleEditAction,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useContentList;
